// extracted by mini-css-extract-plugin
export default {"back-button":"xzbJ8F","backButton":"xzbJ8F","title":"PoY8De","title-text":"VZoaRS","titleText":"VZoaRS"};